// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"57ab3fce","194":"081cb431","339":"dfeaf098","453":"64f3eea1","525":"7c6896f1","562":"30450bf8","858":"9f1104ae","906":"25007e8b"}[chunkId] + ".chunk.js";
};